import React, { useState } from "react";
import OccasionAndNeedTable from "./OccasionAndNeedTable";

const OccasionsOverall = ({
  occasionsTableData,
  occasionQuestion,
  loading,
  hideShowIndex,
}) => {
  const [indexChecked, setIndexChecked] = useState(false);

  const handleIndexToggle = (checked) => {
    setIndexChecked(checked);
  };

  return (
    <div className="occasion-overall">
      <OccasionAndNeedTable
        headerText={
          <span>
            XMOT<sup>&reg;</sup> Occasions
          </span>
        }
        headerSubTitle={
          <span>
            Base: XMOT<sup>&reg;</sup> Surveys
          </span>
        }
        subTitle={`% of survey responses`}
        tableData={occasionsTableData}
        question={occasionQuestion}
        handleIndexToggle={handleIndexToggle}
        indexChecked={indexChecked}
        loading={loading}
        hideShowIndex={hideShowIndex}
      />
    </div>
  );
};

export default OccasionsOverall;
